// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AnonymousForSalePropertyAgent",
    "VisibleForSalePropertyAgent"
  ]);
}

function unwrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "BuyerNeedAgentMatchLogV5",
    "ForSalePropertyAgentMatchLogV5",
    "RentalNeedAgentMatchLogV5",
    "RentalPropertyAgentMatchLogV5"
  ]);
}

function unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "PropertyLocationWithHiddenAddress",
    "PropertyLocationWithVisibleAddress"
  ]);
}

function unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "PropertyLocationWithHiddenAddress",
    "PropertyLocationWithVisibleAddress"
  ]);
}

function unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "BuyerNeedV5",
    "ForSalePropertyV5",
    "MessageBroadcast",
    "RentalNeedV5",
    "RentalPropertyV5"
  ]);
}

function unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AvailableConversationContext",
    "RemovedConversationContext"
  ]);
}

function unwrap_fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

function unwrap_fragment_byType_ConversationMessageAlert_message_from_byType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

function unwrap_fragment_byType_ConversationMessageAlert_message_status(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "IncomingMessageStatus",
    "OutgoingMessageStatus"
  ]);
}

function unwrap_fragment_byType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AgentMatchLogAlert",
    "ConversationMessageAlert"
  ]);
}

let fragmentConverter = {"__root":{"timestamp":{"b":""},"byType_ConversationMessageAlert_message_status":{"u":"fragment_byType_ConversationMessageAlert_message_status"},"byType_ConversationMessageAlert_message_from_byType":{"u":"fragment_byType_ConversationMessageAlert_message_from_byType"},"byType_ConversationMessageAlert_message_from":{"f":""},"byType_ConversationMessageAlert_conversation_messages_edges_node_from":{"u":"fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from"},"byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation":{"u":"fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation"},"byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation":{"u":"fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation"},"byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context":{"u":"fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context"},"byType_ConversationMessageAlert_conversation_conversationContext":{"u":"fragment_byType_ConversationMessageAlert_conversation_conversationContext"},"byType_AgentMatchLogAlert_agentMatchLog_byType_RentalPropertyAgentMatchLogV5_source_agent":{"f":""},"byType_AgentMatchLogAlert_agentMatchLog_byType_RentalPropertyAgentMatchLogV5":{"f":""},"byType_AgentMatchLogAlert_agentMatchLog_byType_RentalNeedAgentMatchLogV5_source_agent":{"f":""},"byType_AgentMatchLogAlert_agentMatchLog_byType_RentalNeedAgentMatchLogV5":{"f":""},"byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2_VisibleForSalePropertyAgent_agent":{"f":""},"byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2":{"u":"fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2"},"byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5":{"f":""},"byType_AgentMatchLogAlert_agentMatchLog_byType_BuyerNeedAgentMatchLogV5_source_agent":{"f":""},"byType_AgentMatchLogAlert_agentMatchLog_byType_BuyerNeedAgentMatchLogV5":{"f":""},"byType_AgentMatchLogAlert_agentMatchLog_byType":{"u":"fragment_byType_AgentMatchLogAlert_agentMatchLog_byType"},"byType":{"u":"fragment_byType"}}};

let fragmentConverterMap = {
  fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2: unwrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2,
  fragment_byType_AgentMatchLogAlert_agentMatchLog_byType: unwrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType,
  fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation: unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation,
  fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation: unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation,
  fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context: unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context,
  fragment_byType_ConversationMessageAlert_conversation_conversationContext: unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext,
  fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from: unwrap_fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from,
  fragment_byType_ConversationMessageAlert_message_from_byType: unwrap_fragment_byType_ConversationMessageAlert_message_from_byType,
  fragment_byType_ConversationMessageAlert_message_status: unwrap_fragment_byType_ConversationMessageAlert_message_status,
  fragment_byType: unwrap_fragment_byType
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function alertStatus_decode($$enum) {
  if ($$enum === "DISMISSED" || $$enum === "NEW") {
    return $$enum;
  }
}

let alertStatus_fromString = alertStatus_decode;

function buyerNeedMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST" || $$enum === "QUIET") {
    return $$enum;
  }
}

let buyerNeedMatchingType_fromString = buyerNeedMatchingType_decode;

function conversationContextTypeV5_decode($$enum) {
  if ($$enum === "BROADCAST_MESSAGE" || $$enum === "RENTAL_PROPERTY" || $$enum === "BUYER_NEED" || $$enum === "RENTAL_NEED" || $$enum === "DEVELOPMENT_PROJECT" || $$enum === "FOR_SALE_PROPERTY" || $$enum === "DEVELOPMENT_SAMPLE_UNIT") {
    return $$enum;
  }
}

let conversationContextTypeV5_fromString = conversationContextTypeV5_decode;

let Utils = {
  alertStatus_decode: alertStatus_decode,
  alertStatus_fromString: alertStatus_fromString,
  buyerNeedMatchingType_decode: buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: buyerNeedMatchingType_fromString,
  conversationContextTypeV5_decode: conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: conversationContextTypeV5_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Agent",
    "kind": "LinkedField",
    "name": "agent",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AgentProfilePhoto_agent"
      }
    ],
    "storageKey": null
  }
],
v3 = [
  (v0/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = [
  (v1/*: any*/)
],
v6 = [
  (v1/*: any*/),
  (v4/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "FULL"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"FULL\")"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "maxPrice",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "minPrice",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v9/*: any*/)
      ],
      "type": "PropertyLocationWithHiddenAddress",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true
  },
  "name": "AlertsDropdownItem_alert",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timestamp",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "fragment": {
        "kind": "InlineFragment",
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "agentMatchLog",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "databaseId",
                    "storageKey": null
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "NotificationWidgetTextsRentalProperty_aml"
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RentalPropertyV5",
                              "kind": "LinkedField",
                              "name": "source",
                              "plural": false,
                              "selections": (v2/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "type": "RentalPropertyAgentMatchLogV5",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "NotificationWidgetTextsBuyerNeed_aml"
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "BuyerNeedV5",
                              "kind": "LinkedField",
                              "name": "source",
                              "plural": false,
                              "selections": (v2/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "type": "BuyerNeedAgentMatchLogV5",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "NotificationWidgetTextsRentalNeed_aml"
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RentalNeedV5",
                              "kind": "LinkedField",
                              "name": "source",
                              "plural": false,
                              "selections": (v2/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "type": "RentalNeedAgentMatchLogV5",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "NotificationWidgetTextsForSaleProperty_aml"
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ForSalePropertyV5",
                              "kind": "LinkedField",
                              "name": "source",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "agentV2",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": (v3/*: any*/),
                                      "type": "AnonymousForSalePropertyAgent",
                                      "abstractKey": null
                                    },
                                    {
                                      "kind": "InlineFragment",
                                      "selections": (v2/*: any*/),
                                      "type": "VisibleForSalePropertyAgent",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "ForSalePropertyAgentMatchLogV5",
                          "abstractKey": null
                        }
                      ],
                      "type": null,
                      "abstractKey": null
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "byType"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMatchLogAlert",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationMessageV5",
                "kind": "LinkedField",
                "name": "message",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "from",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ConversationParticipantProfilePhoto_participant"
                      },
                      {
                        "fragment": {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v4/*: any*/),
                                (v1/*: any*/)
                              ],
                              "type": "Agent",
                              "abstractKey": null
                            }
                          ],
                          "type": null,
                          "abstractKey": null
                        },
                        "kind": "AliasedInlineFragmentSpread",
                        "name": "byType"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "IncomingMessageStatus",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "OutgoingMessageStatus",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      }
                    ],
                    "concreteType": "ConversationMessagesConnection",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationMessagesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMessageV5",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v5/*: any*/),
                                    "type": "Agent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "messages(first:1)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "conversationContext",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "entityType",
                            "storageKey": null
                          }
                        ],
                        "type": "RemovedConversationContext",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "context",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "matchingType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "CatchField",
                                    "field": {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Buyer",
                                      "kind": "LinkedField",
                                      "name": "client",
                                      "plural": false,
                                      "selections": (v6/*: any*/),
                                      "storageKey": null
                                    },
                                    "to": "RESULT"
                                  },
                                  (v8/*: any*/)
                                ],
                                "type": "BuyerNeedV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "CatchField",
                                    "field": {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Renter",
                                      "kind": "LinkedField",
                                      "name": "client",
                                      "plural": false,
                                      "selections": (v6/*: any*/),
                                      "storageKey": null
                                    },
                                    "to": "RESULT"
                                  },
                                  (v8/*: any*/)
                                ],
                                "type": "RentalNeedV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "CatchField",
                                    "field": {
                                      "alias": "propertyClient",
                                      "args": null,
                                      "concreteType": "Landlord",
                                      "kind": "LinkedField",
                                      "name": "client",
                                      "plural": false,
                                      "selections": (v5/*: any*/),
                                      "storageKey": null
                                    },
                                    "to": "RESULT"
                                  },
                                  (v10/*: any*/)
                                ],
                                "type": "RentalPropertyV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "CatchField",
                                    "field": {
                                      "alias": "propertyClient",
                                      "args": null,
                                      "concreteType": "Seller",
                                      "kind": "LinkedField",
                                      "name": "client",
                                      "plural": false,
                                      "selections": (v5/*: any*/),
                                      "storageKey": null
                                    },
                                    "to": "RESULT"
                                  },
                                  (v10/*: any*/)
                                ],
                                "type": "ForSalePropertyV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subject",
                                    "storageKey": null
                                  }
                                ],
                                "type": "MessageBroadcast",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AvailableConversationContext",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ConversationMessageAlert",
            "abstractKey": null
          }
        ],
        "type": null,
        "abstractKey": null
      },
      "kind": "AliasedInlineFragmentSpread",
      "name": "byType"
    }
  ],
  "type": "AlertV5",
  "abstractKey": "__isAlertV5"
};
})());

let wrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2 = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType_ConversationMessageAlert_message_from_byType = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType_ConversationMessageAlert_message_status = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_byType = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2 = unwrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2;
exports.wrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2 = wrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType_ForSalePropertyAgentMatchLogV5_source_agentV2;
exports.unwrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType = unwrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType;
exports.wrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType = wrap_fragment_byType_AgentMatchLogAlert_agentMatchLog_byType;
exports.unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation = unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation;
exports.wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation = wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_propertyLocation;
exports.unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation = unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation;
exports.wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation = wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context_RentalPropertyV5_propertyLocation;
exports.unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context = unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context;
exports.wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context = wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext_AvailableConversationContext_context;
exports.unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext = unwrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext;
exports.wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext = wrap_fragment_byType_ConversationMessageAlert_conversation_conversationContext;
exports.unwrap_fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from = unwrap_fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from;
exports.wrap_fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from = wrap_fragment_byType_ConversationMessageAlert_conversation_messages_edges_node_from;
exports.unwrap_fragment_byType_ConversationMessageAlert_message_from_byType = unwrap_fragment_byType_ConversationMessageAlert_message_from_byType;
exports.wrap_fragment_byType_ConversationMessageAlert_message_from_byType = wrap_fragment_byType_ConversationMessageAlert_message_from_byType;
exports.unwrap_fragment_byType_ConversationMessageAlert_message_status = unwrap_fragment_byType_ConversationMessageAlert_message_status;
exports.wrap_fragment_byType_ConversationMessageAlert_message_status = wrap_fragment_byType_ConversationMessageAlert_message_status;
exports.unwrap_fragment_byType = unwrap_fragment_byType;
exports.wrap_fragment_byType = wrap_fragment_byType;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
